<template>
    <div>
        <playback-control v-bind:namespace="namespace"  
                          v-bind:i="i"
                          style="width: 100%;"></playback-control> 

        <div v-if="showLevels" style="width: 100%; border-bottom: 1px solid gray; border-top: 0px solid gray; border-right: 0px solid gray;
                 padding-top: 5px">
            <div class="row">
                <equity-widget v-bind:namespace="namespace" group="bronze" v-bind:dailyClose="close"/>
                <equity-widget v-bind:namespace="namespace" group="silver" v-bind:dailyClose="close"/>
                <equity-widget v-bind:namespace="namespace" group="gold" v-bind:dailyClose="close"/>
            </div>
        </div>

        <b-modal v-bind:id="'breakpoint-modal-' + moduleIndex" :modal-class="myclass" ref="my-modal" @hide="resetModal">
            <template #modal-title >
                <span style="text-align: left; font-size: 20px"> {{currentBreakpoint.title}}</span><!-- - -->
                <!--span style="text-align: right; font-size: 16px">{{moment(currentBreakpoint.date).format("MMM DD, YYYY")}}</span-->
            </template>

            <div class="col-12">
                <h3 v-if="pl == 0 " class="btn d-block ml-auto mr-auto mt-3 mb-5" style="font-size: 20px;color: #181C32;background-color: transparent;border-color: #181C32;width: 200px;">
                 <div class="row mt-0 mb-0">
                    <div class="col-5 p-1"><p class="text-dark-75 font-weight-bolder m-1">P/L:</p></div>
                    <div class="col-7 p-1 pt-2">0 $</div>
                  </div>
                 </h3>
                <h3 v-if="pl < 0 " class="btn btn-outline-danger d-block ml-auto mr-auto mt-3 mb-5" style="font-size: 20px;color: #F64E60;background-color: transparent;border-color: #F64E60;width: 200px;">
                    <div class="row mt-0 mb-0">
                        <div class="col-5 p-1"><p v-if="this.$store.state[this.namespace].asset!='Options'" class="text-dark-75 font-weight-bolder m-1">P/L:</p></div>
                        <div class="col-7 p-1 pt-2">{{ truncatePl(pl * multiplier) }} $</div>
                      </div>
                  </h3>
                  <h3 v-if="pl> 0 " class="btn btn-success-dark d-block ml-auto mr-auto mt-3 mb-5" style="font-size: 20px;color: #1BC5BD;background-color: transparent;border-color: #1BC5BD;width: 200px;">
                      <div class="row mt-0 mb-0">
                        <div class="col-5 p-1"><p v-if="this.$store.state[this.namespace].asset!='Options'" class="text-dark-75 font-weight-bolder m-1">P/L:</p></div>
                        <div class="col-7 p-1 pt-2">{{truncatePl(pl * multiplier)}} $</div>
                      </div>
                  </h3>
                <p style="text-align: center; font-size: 16px;"> {{currentBreakpoint.message}} </p>
            </div>

            <template #modal-footer>
              <div class="w-100">
                <div class="row" v-if="currentBreakpoint.type != '-' && currentBreakpoint.type != 'Stop Loss'">
                    <div class="col-12">
                        <button variant="success"  class="btn mt-3 btn-md btn-primary align-center d-flex"
                        @click="$bvModal.hide('breakpoint-modal-'+moduleIndex)">Close</button>
                    </div>
                </div>
                <div class="row" v-if="currentBreakpoint.type == '-'  && pl>0">
                    <span style="margin-left: auto;font-size: 15px;margin-right: auto;">Vuoi chiudere ora l’operazione o proseguire con il trade?</span>
                    <div class="col-6">
                        <button variant="success" 
                        style="width: 160px;"
                        class="btn mt-3 btn-md btn-primary float-right d-block"
                        @click="pause();choice='next';$root.$emit('skip_breakpoint');$bvModal.hide('breakpoint-modal-'+moduleIndex);">Proseguo</button>
                    </div>
                    <div class="col-6">
                        <button variant="success" 
                        style="width: 160px;"
                        class="btn mt-3 btn-md btn-success" @click="$root.$emit('get_profit');choice='ok';$bvModal.hide('breakpoint-modal-'+moduleIndex);">Chiudo l'operazione</button>
                    </div>
                </div>

                <div class="row" v-if="currentBreakpoint.type == '-'  && pl==0">
                    <span style="margin-left: auto;font-size: 15px;margin-right: auto;">Vuoi chiudere ora l’operazione o proseguire con il trade?</span>
                    <div class="col-6">
                        <button variant="success" 
                        style="width: 160px;"
                        class="btn mt-3 btn-md btn-primary float-right d-block"
                        @click="pause();choice='next';$root.$emit('skip_breakpoint');$bvModal.hide('breakpoint-modal-'+moduleIndex);">Proseguo</button>
                    </div>
                    <div class="col-6">
                        <button variant="success" 
                        style="width: 160px;"
                        class="btn mt-3 btn-md btn-success" @click="$root.$emit('get_profit');choice='ok';$bvModal.hide('breakpoint-modal-'+moduleIndex);">Chiudo l'operazione</button>
                    </div>
                </div>

                <div class="row" v-if="currentBreakpoint.type == '-' && pl<0">
                    <span style="margin-left: auto;font-size: 15px;margin-right: auto;">Vuoi chiudere ora l’operazione o proseguire con il trade?</span>
                    <div class="col-6">
                        <button variant="success" class="btn mt-3 btn-md btn-primary float-right d-block"
                        @click="pause();choice='next';$root.$emit('skip_breakpoint');$bvModal.hide('breakpoint-modal-'+moduleIndex);">Proseguo</button>
                    </div>
                    <div class="col-6">
                        <button variant="success" 
                        style="width: 160px;"
                        class="btn mt-3 btn-md btn-danger" @click="$root.$emit('get_loss');choice='ok';$bvModal.hide('breakpoint-modal-'+moduleIndex)">Chiudo l'operazione</button>
                    </div>
                </div>
            </div>
          </template>
        </b-modal>

        <b-modal id="end-modal" hide-footer :modal-class="myclass" @hide="resetEndModal">
            <template #modal-title>
                <span style="text-align: left; font-size: 20px"> Strategia conclusa</span>
            </template>
           <div class="row">
                <div class="col-12">
                    <p v-if="event=='Take Profit'" style="text-align: center; font-size: 16px;">
                    La strategia ha avuto un profitto di {{ truncatePl(pl * multiplier) }} $
                    </p>
                    <p v-if="event=='Stop Loss'" style="text-align: center; font-size: 16px;">
                    La strategia ha avuto una perdita di {{ margin }} $
                    </p>
                    <p v-if="event=='no'" style="text-align: center; font-size: 16px;">
                        <span v-if="pl>0">La strategia ha avuto un profitto di {{ truncatePl(pl * multiplier) }} $</span>
                        <span v-if="pl<0">La strategia ha avuto una perdita di {{ truncatePl(pl * multiplier) }} $</span>
                        <span v-if="pl==0">La soglia scelta non è stata raggiunta!</span>
                    </p>
                </div>
                <div class="col-12" v-if="event=='Take Profit' || event=='no'">
                    <button variant="success" class="btn mt-3 btn-md btn-primary m-auto d-flex"
                    @click="$root.$emit('get_profit');choice='results';$bvModal.hide('end-modal')">Vai ai risultati</button>
                </div>
                <div class="col-12" v-if="event=='Stop Loss'">
                    <button variant="success" class="btn mt-3 btn-md btn-primary m-auto d-flex"
                    @click="$root.$emit('get_loss');choice='results';$bvModal.hide('end-modal')">Vai ai risultati</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style>
.myclass > div  {
   position: fixed !important;
   width: 500px !important;
   top: 20% !important;
   left: 33% !important;
}

.myclass > .modal-dialog > .modal-content {
  display: inline-block;
}
</style>

<script>

    import playbackControl from '@/components/playback-control';
    import equityWidget from '@/components/equity-widget';
    import moment from "moment";
    import {getDaysArray} from "../js/main.js";
    import {updateVolumeProfile} from "../js/am4charts-plugins/volumeProfile";

    export default {
        components: {
            playbackControl, equityWidget
        },
        mounted() {
            console.log("playback.vue mounted() starting.");
            console.log("this.namespace=", this.namespace);
            console.log("this.moduleIndex=", this.moduleIndex);
            this.$root.$on('playback_rewind', () => {
                // your code goes here
                this.rewind()
            });
            this.$root.$on('playback_pl_update', (value) => {
                // your code goes here
                if(value!=undefined && value!="-") {
                    this.pl = parseFloat(value.toString().replace('$','').replace(/[^0-9.-]+/g,""));
                }
            });
            this.$root.$on('playback_play', () => {
                this.play();    
            });
            this.$root.$on('playback_pause', () => {
                // your code goes here
                this.pause()
            });
        },
        props: ['namespace', 'parsedData', 'chart'],
        data: function () {
            return {
                pl_nr : 0,
                choice: null,
                timer: null,
                i: null,
                newData: [],
                closes: [],
                currentBreakpoint: {},
                moduleIndex: this.namespace.replace("generalFormTab", ""),
                myclass: ['myclass'],
                pl: this.$store.state[this.namespace].prize=="" ? 0 : parseFloat(this.$store.state[this.namespace].prize),
                multiplier: parseFloat(this.$store.state[this.namespace].stock_multiplier==undefined ? 1 : parseFloat(this.$store.state[this.namespace].stock_multiplier)),
                event: this.$store.state[this.namespace].event=="" ? "no" : this.$store.state[this.namespace].event,
                margin: this.$store.state[this.namespace].margin
            }
        },
        computed: {
            activeModuleName() {
                let activeModuleName = this.$store.getters['activeModuleName'];
                // console.log("activeModuleName=", activeModuleName);
                return activeModuleName;
            },
            start() {
                return this.$store.state[this.namespace].playback.start;
            },
            end() {
                return this.$store.state[this.namespace].playback.end;
            },
            breakpoints: {
                get() {
                    // console.log("this.$store.state[this.namespace].playback=", this.$store.state[this.namespace].playback);
                    // console.log("this.$store.state[this.namespace].playback.breakpoints=",  JSON.parse(JSON.stringify(this.$store.state[this.namespace].playback.breakpoints)));
                    return this.$store.state[this.namespace].playback.breakpoints;
                },
                set() {}
            },
            breakpointDates() {
                if (typeof this.breakpoints !== 'undefined') {
                    return this.breakpoints.map(x => x.date);
                } else {
                    return null;
                }
            },
            close() {
                var obj = new Object();
                if (typeof this.newData[this.i - 1] !== 'undefined' && this.i > 1) {
                    // console.log("this.newData[this.i-1].date=", this.newData[this.i-1].date);
                    // console.log("this.i=", this.i);
                    // console.log("this.closes=",  JSON.parse(JSON.stringify(this.closes)));
                    let close = this.closes.find(x => x.date === this.newData[this.i - 1].date).close;
                    obj['close'] = close;
                    if(this.pl!=0) this.$root.$emit('pl_nr_update',this.pl);
                } else {
                    obj['close'] = "-";
                }
                return obj;
            },
            showLevels() {
                return this.$store.state[this.namespace].addHorizontalLine;
            },
            buySell() {
                return this.$store.state[this.namespace].buySell;
            }
        },
        watch: {
            activeModuleName: function () {
                console.log("playback.js watch activeModuleName is changing.");
                this.pause();
            },
            buySell: function (buySell) {
               console.log("watch buySell = ", buySell);
               if(location.href.indexOf("exercises")<0) {
                    this.rewind();
               }
            }
        },
        methods: {
            truncatePl(value) {
                return parseFloat(value).toFixed(2);
            },
            resetModal() {
                if(this.choice==null)
                this.$nextTick(() => {
                  this.$bvModal.show('breakpoint-modal-' + this.moduleIndex)
                })
            },
            resetEndModal() {
                if(this.choice==null)
                this.$nextTick(() => {
                  this.$bvModal.show('end-modal');
                })
            },
            moment: function (date) {
                return moment(date);
            },
            pause() {
                clearInterval(this.timer);
                this.timer = null;
                this.$root.$emit('set_pause');
            },
            oneStepBackward() {
                console.log("oneStepBackward.");
                this.chart.series.values.forEach(function (series) {
                    // console.log("series.id=", series.id);
                    if (!series.id.includes("-y") && !series.id.includes("scrollbar") && !series.id.includes("profit-loss") && !series.id.includes("horizontal")) {
                        // console.log("series.id=", series.id);
                        let truncatedData = [...series.data].slice(0, -1);
                        // console.log("truncatedData=", truncatedData);
                        series.data = truncatedData;
                    }
                });
                this.i--;
                if ((this.$store.state[this.namespace].legs == 1 || (["BasicCharts", "Playback"].includes(this.$store.state[this.namespace].program)
                        && this.$store.state[this.namespace].dataSource !== "csi")) && this.$store.state[this.namespace].addVolumeProfile) {
                    let generalForm = JSON.parse(JSON.stringify(this.$store.state[this.namespace]));
                    updateVolumeProfile(this.chart, generalForm);
                }
            },
            oneStepForward() {
                // console.log("oneStepForward.");
                let singleStep = true;
                this.play(singleStep);
            },
            play(singleStep = false) {
                console.log("playing.");
                let that = this;
                function startInterval() {
                    console.log("startInterval() starting.");
                    if (that.timer == null) {

                        that.timer = setInterval(function () {
                            // let i = that.$store.state[that.namespace].playback.i;
                            //  console.log("i=", i, " that.timer=", that.timer);
                            //  console.log("that.breakpointDates=", that.breakpointDates);
                            console.log("namespace=", that.namespace, " that.i=" + that.i + "  " + that.newData[that.i].date + "   " + moment(that.newData[that.i].date).format('dddd'));
                            if (that.i > 0 && typeof that.breakpoints !== 'undefined' && that.breakpointDates.includes(that.newData[that.i].date)) {
                                let breakpoint = that.breakpoints.find(x => x.date == that.newData[that.i].date);
                                //  breakpoint.date = moment(breakpoint.date).format("MMM DD, YYYY");
                                that.currentBreakpoint = breakpoint;

                                // console.log("that.currentBreakpoint=", that.currentBreakpoint);
                                that.pause();
                                that.$bvModal.show('breakpoint-modal-' + that.moduleIndex);
                                //alert(currentBreakpoint.date + " -  " + currentBreakpoint.title + " :  " + currentBreakpoint.message);
                                // that.play();
                            }

                            // console.log("that.end=", that.end);
                            // console.log("that.newData[that.i]=", that.newData[that.i]);
                            if (that.i !== null && that.i < that.newData.length && !moment(that.newData[that.i].date).isAfter(moment(that.end))) {
                             // console.log("namespace=", that.namespace, " that.i=" + that.i + "  " + that.newData[that.i].date + "   " + moment(that.newData[that.i].date).format('dddd'));
                                that.chart.series.each(function (series) {
                                    if (!series.id.includes("-y") && !series.id.includes("scrollbar") && !series.id.includes("profit-loss") && !series.id.includes("horizontal")) {
                                        series.addData(that.newData[that.i], 0);
                                    }
                                });
                                if ((that.$store.state[that.namespace].legs == 1 || (["BasicCharts", "Playback"].includes(that.$store.state[that.namespace].program)
                                        && that.$store.state[that.namespace].dataSource !== "csi")) && that.$store.state[that.namespace].addVolumeProfile) {
                                    let generalForm = JSON.parse(JSON.stringify(that.$store.state[that.namespace]));
                                    updateVolumeProfile(that.chart, generalForm);
                                }
                                let dates = that.closes.map(x => x.date);
                                //  console.log("dates=", dates);
                                //  console.log("dates.includes(that.newData[that.i].date)=", dates.includes(that.newData[that.i].date));
                                if (!dates.includes(that.newData[that.i].date)) {
                                    if (typeof that.newData[that.i].close !== 'undefined' && that.newData[that.i].close !== null) {
                                        that.closes.push({date: that.newData[that.i].date, close: that.newData[that.i].close});
                                    } else {
                                        that.closes.push({date: that.newData[that.i].date, close: that.closes[that.i - 1].close});
                                    }
                                }
                                that.i++;
                                if (singleStep)
                                    that.pause();
                              /*  if(moment(that.newData[that.i].date).isSame(moment(that.end))){
                                   that.$bvModal.show('end-modal');
                                }*/
                            } else {
                                // console.log("Up to date.");
                                clearInterval(that.timer);
                                that.timer = null;
                                that.$bvModal.show('end-modal');
                                // alert(moment(that.newData[that.i - 1].date).format("YYYY-MM-DD") + ": END OF THE EXERCISE");
                                return;
                            }
                        }, 1000 * that.$store.state[that.namespace].playback.interval);

                    }
                }
                startInterval();
            },
            rewind() {
                console.log("rewind() starting. namespace=", this.namespace);
                //console.log("this.$refs=", this.$refs);

                clearInterval(this.timer);
                this.timer = null;
                this.newData = [];
                this.i = 0;
                this.closes = [];

                let start = this.start;
                console.log("start=", start);
                console.log("this.chart=", this.chart);
                this.chart.series.values.forEach(function (series) {
                    // console.log("series.id=", series.id);
                    if (!["-y", "scrollbar", "profit-loss"].some(x => series.id.includes(x))) {
                        // if (!series.id.includes("-y") && !series.id.includes("scrollbar") && !series.id.includes("profit-loss")) {
                        console.log("series.id=", series.id);
                        let truncatedData = [...series.data].filter(x => x.date <= start);
                        // console.log("truncatedData=", truncatedData);
                        series.data = truncatedData;
                    }
                });

                if ((this.$store.state[this.namespace].legs == 1 || (["BasicCharts", "Playback"].includes(this.$store.state[this.namespace].program)
                        && this.$store.state[this.namespace].dataSource !== "csi")) && this.$store.state[this.namespace].addVolumeProfile) {
                    let generalForm = JSON.parse(JSON.stringify(this.$store.state[this.namespace]));
                    updateVolumeProfile(this.chart, generalForm);
                }

                let temp = Object.values(this.parsedData.values).filter(x => x.date >= this.start);
                // console.log("this.newData=", this.newData);

                let seriesStart = temp[0].date;
                let seriesEnd = temp[temp.length - 1].date;
                console.log("seriesStart=", seriesStart, " seriesEnd=", seriesEnd);

                let daylist = getDaysArray(moment(seriesStart).add(1, 'days'), moment(seriesEnd)).map(x => x.format("YYYY-MM-DD"));
                // console.log("daylist=", daylist);

                let paddedData = daylist.map(date => {
                    // console.log("date=", date, parsedData.values.find(x => x.date === date));
                    if (typeof temp.find(x => x.date === date) !== 'undefined') {
                        return temp.find(x => x.date === date);
                    } else {
                        return {date: date}
                    }
                });
                console.log("paddedData=", paddedData);
                this.newData = paddedData;

                this.oneStepForward();
            }
        }
    }
</script>

